var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21.961,
    viewBox: "0 0 16 21.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,19.485V5a1,1,0,0,1,2,0V20.961a1,1,0,0,1-1.371.929L11.06,20.465,8.939,21.594a2,2,0,0,1-1.879,0L4.94,20.465,1.371,21.889A1,1,0,0,1,0,20.961V1a1,1,0,0,1,1.445-.9L4.928,1.838,6.895.534a2,2,0,0,1,2.21,0l1.966,1.3L14.555.106a1,1,0,1,1,.89,1.791L11.962,3.629a2,2,0,0,1-2-.124L8,2.2,6.034,3.5a2,2,0,0,1-2,.124L2,2.615v16.87l2.2-.877a2,2,0,0,1,1.68.092L8,19.828,10.121,18.7a2,2,0,0,1,1.68-.092Z",
    transform: "translate(0 0.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(4 11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(4 7.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(4 15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPo);
export default __webpack_public_path__ + "static/media/po.3d8dfdd940bd08908982bcc907a6ec21.svg";
export { ForwardRef as ReactComponent };